import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';

const CSVProcessingDialog = ({ open }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Processing CSV File</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="body1" gutterBottom>
            Analyzing and validating user data...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we process your file
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CSVProcessingDialog;